<template>
    <modal
        :is-open="isOpen"
        :is-loading="loading"
        :disabled="loading"
        title="Удалить список?"
        btn-save-title="Удалить"
        @onCloseModal="closeModal"
        @onSaveModal="confirmModal"
    >
        Список изделий <strong>{{ list && list.ListName }}</strong> будет удален
    </modal>
</template>

<script>
import Modal from '@/components/Elements/Modal'

export default {
    name: 'RemoveListModal',
    components: { Modal },
    props: {
        list: {
            type: [Object, null],
            default: () => {
                return {}
            }
        },
        isOpen: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loading: false
        }
    },
    methods: {
        closeModal() {
            this.$emit('onClose')
        },
        confirmModal() {
            this.$emit('onConfirm', this.list)
        }
    }
}
</script>
